<template>
	<v-card height="100%">
		<!-- <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs> -->
		<v-card-text class="pt-0">
			<v-row dense>
				<!-- 日历表 -->
				<v-col cols="12" class="mt-1">
					<v-sheet height="64" min-width="1100">
						<v-toolbar color="info" flat>
	
							<div style="width: 230px;  height: 50px;" class="pt-1">
								<v-autocomplete :items="selectTeacherList" v-model="query.teacher" item-text="trueName" color="white"
									item-value="id" label="老师" dense outlined clearable @change="getScheduleData"></v-autocomplete>
							</div>	
							
							<v-spacer></v-spacer>
							<v-btn fab text small color="grey darken-2" @click="prev">
								<v-icon color="white">
									mdi-chevron-left
								</v-icon>
							</v-btn>
							<v-toolbar-title v-if="$refs.calendar">
								<span style="color:white">{{ query.start }} - {{query.end}}</span>
							</v-toolbar-title>
							<v-btn fab text small color="grey darken-2" @click="next">
								<v-icon color="white">
									mdi-chevron-right
								</v-icon>
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn outlined class="mr-4 ml-2" color="white darken-2" @click="setToday">
								返回
							</v-btn>
							<v-btn outlined class="mr-4 ml-2" color="white darken-2" @click="getScheduleData">
								刷新
							</v-btn>
							<v-btn outlined class="mr-4 ml-2" color="white darken-2" @click="toMonth">
								月课表
							</v-btn>
						</v-toolbar>
					</v-sheet>
					<v-sheet height="100%" min-width="1100">
						<v-calendar ref="calendar" v-model="value" color="purple lighten-3" @click:date="dayClicked"
							:type="type"  :weekdays="weekDays" locale="zhHans" :short-intervals="false" @change="updateRange">

							 <template v-slot:day-body="{ date, week }">
								<template v-if="dateDataMap[date]">
									<!-- 每一个课次 -->
									<v-sheet width="150px" tile class="d-flex mb-1 ml-2" style="position: absolute;" 
									v-for="(item,index) in dateDataMap[date]" :key="index"
									:style="{ top: itemTop(item) }" @click="viewRecord(item)">
										<div class="d-flex flex-column" :class="divHeaderClass(item)">
											<div class="ml-1">
												<span>{{item.teacherName}}</span>
												<span class="ml-1">{{item.timeFrom}}-{{item.timeTo}}</span>
											</div>
											<div class="mt-n1 ml-1">
												<span>{{item.className}}</span> 
												<!-- <span>{{item.roomName}}</span> -->
											</div>
										</div>
									</v-sheet>
								</template>
							</template>
						</v-calendar>
					</v-sheet>
				</v-col>
			</v-row>
		</v-card-text>
		
		<!-- 课程详情组件 -->
		<recordInfoView :show="recordView.show" :recordId="recordView.recordId" @cancel="recordView.show=false"></recordInfoView>
		<!-- 日排课明细 -->
		<dayRecordList :show="dayRecordListView.show" :classDate="dayRecordListView.classDate" @cancel="dayRecordListView.show=false"></dayRecordList>
	</v-card>
</template>

<script>
	import global from '../../../config/global'
	import utils from "../../../config/utils"
	import recordInfoView from "../../../components/record_info_view.vue"
	import dayRecordList from "../../../components/day_record_list.vue"
	export default {
		name: "week-schedule",
		components:{recordInfoView,dayRecordList},
		data() {
			return {
				value: '',
				ready: false,
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '教务中心',
						disabled: true
					},
					{
						text: '周课程表',
						disabled: true
					},
				],

				selectTeacherList: [], //选择老师数据源
				query: {
					loading: false,
					page: 1,
					size: 20,
					teacher: "",
					start:"",
					end:""
				},
				type: 'week',
				weekDays: [1, 2, 3, 4, 5, 6, 0],
				dateDataMap: {},// 每日数据
				recordView:{
					show:false,
					recordId:""
				},
				dayRecordListView:{
					show:false,
					classDate:""
				}

			}
		},
		created() {
			// 获取门店列表
			this.getTeacherListForSelect();
		},
		mounted() {
			this.ready = true
			this.scrollToTime()
			this.updateTime()
			this.$refs.calendar.checkChange()
		},
		computed: {
			cal () {
				return this.ready ? this.$refs.calendar : null
			},
			nowY () {
				return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
			},
		},
		methods: {
			toMonth(){
				// 切换月历
				this.$router.push("/edu/schedule/list");
			},
			itemTop(item){
				// item出现的高度
				let itewTimeStr = item.classDate + " "+item.timeFrom +":00";
				
				const itemTime = new Date(itewTimeStr)
				
				return this.cal ? this.cal.timeToY({ hour: itemTime.getHours(), minute: itemTime.getMinutes() },) + 'px' : '-10px'
			},
			
			getCurrentTime () {
				return this.cal ? this.cal.times.now.hour * 60 + this.cal.times.now.minute : 0
			},
			scrollToTime () {
				const time = this.getCurrentTime()
				const first = Math.max(0, time - (time % 30) - 30)
		
				this.cal.scrollToTime(first)
			},
			updateTime () {
				setInterval(() => this.cal.updateTimes(), 60 * 1000)
			},
			viewRecord(item){
				this.recordView.recordId = item.id;
				this.recordView.show=true;
			},
			getTeacherListForSelect() {

				const shopId = utils.getCurrentShopId();


				const that = this;
				let url = `/edu/shop/teacher/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			divHeaderClass(item){
				let result = "";
				if (item.status == '1'){
					result = "item_content_wait";
				}else if (item.status =='2'){
					result = "item_content_approved";
				}else if (item.status =='3'){
					result = "item_content_delay";
				}
				return result;
			},
			// viewDay({
			// 	date
			// }) {
			// 	this.focus = date;
			// 	this.type = 'day';
			// 	this.$refs.calendar.scrollToTime('08:00');
			// },
			dayClicked({
				date
			}){
				console.log("clicked date:",date);
				this.dayRecordListView.classDate = date;
				this.dayRecordListView.show = true;
			},
			setToday() {
				// 返回今天
				this.value = ''
			},
			prev() {
				this.$refs.calendar.prev()
			},
			next() {
				this.$refs.calendar.next()
			},
			updateRange({
				start,
				end
			}) {
				this.query.start = start.date;
				this.query.end = end.date;

				this.getScheduleData();

			},
			getScheduleData() {
				// 获取数据
				const shopId = utils.getCurrentShopId();
				const that = this;
				
				let url = `/edu/schedule/record/list/date/${this.query.start}/${this.query.end}?v=1`
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.teacher) {
					url += "&teacher=" + this.query.teacher;
				}

				console.log(url);

				this.axios.get(url).then(response => {
					if (response.data["code"] === 200) {

						const dataList = response.data["data"];
						
						console.log(">>>>>>>>>>>>>>获取日历数据>>>>>>>>>>>>>>");
						console.log(dataList);
						console.log(">>>>>>>>>>>>>>获取日历数据>>>>>>>>>>>>>>")
						that.dateDataMap = dataList;
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.wait_approve_header{
		background:#42A5F5; 
	}
	.approved_header{
		background:#66BB6A; 
	}
	.delay_header{
		background:#9E9E9E; 
	}
	
	
	.item_content_wait{
		border: solid 1px #EEEEEE;
		border-left:solid 5px #42A5F5; 
		border-radius: 5px; 
		font-size: 12px; 
		background:#f7f8fa; 
		cursor: pointer; 
		width:90%;
		height:40px;
	}
	.item_content_approved{
		border: solid 1px #EEEEEE;
		border-left:solid 5px #66BB6A; 
		border-radius: 5px; 
		font-size: 12px; 
		background:#f7f8fa; 
		cursor: pointer; 
		width:90%;
		height:40px;
	}
	.item_content_delay{
		border: solid 1px #EEEEEE;
		border-left:solid 5px #9E9E9E; 
		border-radius: 5px; 
		font-size: 12px; 
		background:#f7f8fa; 
		cursor: pointer; 
		width:90%;
		height:40px;
	}
	
</style>
